import { useState } from 'react';
import { ExpandableSection } from '@amzn/awsui-components-console';
import { CodeView } from '@amzn/awsui-code-view-components-console';
import type { EvaluationResult } from '@amzn/helianthus-arbiter-client';

interface ResultDisclosureProps {
  result: EvaluationResult;
}

export function ResultDisclosure({ result }: ResultDisclosureProps): React.JSX.Element | null {
  const [expanded, setExpanded] = useState(false);

  const snippet = result.evidence?.code?.snippet;
  if (!snippet) {
    return null;
  }

  return (
    <ExpandableSection
      headerText="Show snippet"
      variant="footer"
      expanded={expanded}
      onChange={({ detail }) => setExpanded(detail.expanded)}
    >
      {expanded && (
        <CodeView
          content={snippet}
          wrapLines
          ariaLabel="Code snippet for this result's location"
        />
      )}
    </ExpandableSection>
  );
}
